import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export const useUserPlan = () => {
  const { user, isAuthenticated } = useAuth();
  const [userPlan, setUserPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (!isAuthenticated || !user) {
        setUserPlan(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // If user has a direct membershipPlan, use it
        if (user.membershipPlan) {
          // If membershipPlan is just an ID, fetch the full plan details
          if (typeof user.membershipPlan === 'string') {
            const response = await api.get(`/plans/${user.membershipPlan}`);
            setUserPlan(response.data.data);
          } else {
            // Already populated
            setUserPlan(user.membershipPlan);
          }
        } else if (user.memberType) {
          // Fallback: Get user's active plan based on their member type (old logic)
          const response = await api.get(`/plans?memberType=${user.memberType._id || user.memberType}&active=true`);
          const plans = response.data.data || [];

          // Find the plan that matches the user's member type
          const matchingPlan = plans.find(plan =>
            plan.memberTypeConfig.some(config =>
              config.memberType === (user.memberType._id || user.memberType) &&
              config.isEligible
            )
          );

          setUserPlan(matchingPlan || null);
        } else {
          setUserPlan(null);
        }
      } catch (err) {
        console.error('Error fetching user plan:', err);
        setError(err.response?.data?.error || 'Failed to load user plan');
        setUserPlan(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserPlan();
  }, [isAuthenticated, user?.membershipPlan, user?.memberType]);

  return { userPlan, loading, error };
};